import { render, staticRenderFns } from "./myOnforestduty.vue?vue&type=template&id=8a62aaf6&"
import script from "./myOnforestduty.vue?vue&type=script&lang=js&"
export * from "./myOnforestduty.vue?vue&type=script&lang=js&"
import style0 from "./myOnforestduty.vue?vue&type=style&index=0&id=8a62aaf6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports